import { SebAutocomplete } from './SebAutocomplete.js';

window.customElements.define('seb-autocomplete', SebAutocomplete);
